import $ from 'jquery';
import _ from 'underscore';
import { encode } from '../../../home24/core/base64';
import { getStorage } from '../../../home24/helpers/storage-factory';
import CartOverlayEvents from '../../tracking/cart/CartOverlayEvents';
import * as commonTrackingHelper from '../../tracking/common/helper';
import * as registry from '../../../home24/core/registry';

export default CartOverlayEvents.extend({

    events: {
        'change .cart-article-quantity': 'onQuantityChange',
        'click .cart-remove-button': 'onRemoveClick',
        'click #js-to-checkout-button': 'toCheckoutClick'
    },

    cookieCallbacks: {
        GtmOnCartQuantityChange: 'afterQuantityChange',
        GtmOnRemovedFromCart: 'afterRemoveClick'
    },

    initialize: function () {

    },

    attachExtraTracking: function () {
    },

    getTrackingData: function () {
        var trackingData = registry.get('trackingData');

        return _.isArray(trackingData) ? trackingData : trackingData.cartContent;
    },

    onRemoveClick: function (event) {
        var $currentTarget = $(event.currentTarget);

        try {
            var articleTrackingData = commonTrackingHelper.extractDataBySku(this.getTrackingData(), $currentTarget.closest('form').find('[name="key[]"]').val().split(';')[1]);

            if (articleTrackingData !== false) {
                getStorage().set('GtmOnRemovedFromCart', encode(JSON.stringify(articleTrackingData)));
            }
        } catch (ignore) { }
    },

    onQuantityChange: function (event) {
        var $currentTarget = $(event.currentTarget);

        try {
            var sku = $currentTarget.closest('form').find('[name="sku[]"]').val().split(';')[1];
            var articleTrackingData = commonTrackingHelper.extractDataBySku(this.getTrackingData(), sku);
            var currentQuantity = articleTrackingData.quantity;
            var newQuantity = parseInt($currentTarget.find('option:selected').text(), 10);
            var dataContent = {};

            dataContent.oldQuantity = currentQuantity;
            dataContent.newQuantity = newQuantity;
            dataContent.sku = sku;

            if (currentQuantity && newQuantity) {
                getStorage().set('GtmOnCartQuantityChange', encode(JSON.stringify(dataContent)));
            }
        } catch (ignore) { }
    },

    /**
     * Callback executed when article has been removed from cart
     * @see REBOOT-14889
     * @param {String} sValue
     */
    afterRemoveClick: function (sValue) {
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push(commonTrackingHelper.prepareCartRemoveObject(commonTrackingHelper.decode(sValue)));
        }
    },

    /**
     * Callback for BaseTracking:executeCookieCallbacks executed when user changes cart quantity
     * and article
     * @param sValue
     */
    afterQuantityChange: function (sValue) {
        if (typeof window.dataLayer !== 'undefined') {
            var oPassedData = commonTrackingHelper.decode(sValue);
            var oArticleData = commonTrackingHelper.extractDataBySku(registry.get('trackingData').cartContent, oPassedData.sku);
            var iQuantityDifference = oPassedData.newQuantity - oPassedData.oldQuantity;

            if (iQuantityDifference > 0) {
                window.dataLayer.push(commonTrackingHelper.prepareCartAddObject(oArticleData, iQuantityDifference));
            } else {
                window.dataLayer.push(commonTrackingHelper.prepareCartRemoveObject(oArticleData, Math.abs(iQuantityDifference)));
            }

        }
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/cart/CartEvents.js
 **/